<h2 lvrPadding [padHorizontal]="32" [padVertical]="0">
	{{ 'assignment.phase.title_' + phaseTransitionType() | transloco }}
</h2>

<div style="margin-bottom: 16px">
	<p style="max-width: 600px">
		{{ 'assignment.phase.' + phaseTransitionType() + '_info' | transloco }}
	</p>
</div>

<lvr-additional-assignment-details
	[assignmentInput]="assignment()"
	[showHeading]="false"
	[showReports]="false"
	[showEditButton]="false"
/>

<lvr-assignment-links
	[clientId]="clientId()"
	[assignmentId]="assignment()!.id"
	[redirectUrl]="currentUrl"
	[isAdditionalAssignmentView]="true"
	[reportId]="shouldBeEndReport() ? reportIdsByType().end : reportIdsByType().start"
	[targetPhase]="targetPhase()"
></lvr-assignment-links>

<lvr-assignment-checks
	[errors]="validationData()!"
	[assignmentId]="assignment()!.id"
	[clientId]="clientId()"
	[isAdditionalAssignment]="true"
	[reportId]="shouldBeEndReport() ? reportIdsByType().end : reportIdsByType().start"
	[targetPhase]="targetPhase()"
></lvr-assignment-checks>

<lvr-default-actions
	[showLoading]="saving()"
	[labelSave]="saveButtonKey()"
	(save)="save()"
	[disableSave]="disableContinueButton()"
	(cancelSave)="cancel()"
></lvr-default-actions>
